import useTheme, { Theme, themeContext } from 'components/App/hooks/useTheme'
import React from 'react'

export interface ThemeProviderProps {
  theme: Theme
  children: React.ReactNode
}

export default function ThemeProvider({ theme, children }: ThemeProviderProps): JSX.Element {
  return (
    <themeContext.Provider value={theme}>
      <HDSTheme>{children}</HDSTheme>
    </themeContext.Provider>
  )
}

interface HDSDataThemeProps {
  children: React.ReactNode
}

function HDSTheme({ children }: HDSDataThemeProps): JSX.Element {
  const [currentTheme, _] = useTheme()
  const dataTheme = getDataTheme(currentTheme)
  const cartographyTheme = getCartographyTheme(currentTheme)

  return (
    <div id="root" data-theme={dataTheme} data-styles="hds">
      <div id="root" data-theme={cartographyTheme} data-styles="hds">
        {children}
      </div>
    </div>
  )
}

function getDataTheme(theme: Theme): string {
  switch (theme) {
    case Theme.dark:
      return 'hds-web-product-dark-theme'
    case Theme.light:
    default:
      return 'hds-web-product-light-theme'
  }
}

function getCartographyTheme(theme: Theme): string {
  switch (theme) {
    case Theme.dark:
      return 'hds-cartography-dark-theme'
    case Theme.hybrid:
      return 'hds-cartography-hybrid-theme'
    case Theme.light:
    default:
      return 'hds-cartography-light-theme'
  }
}
